import RiderWithBenefitModal from './rider-benefit-modal'
import RiderBenefitSummary from './rider-benefit-summary'
import MESSAGES from 'core/data-model/constants/bi-messages'
import { AgentProtectionDisclaimer } from './agent-protection-disclaimer'

// const renderImportantExceptionNotes = () => {
//   const exceptionNotes = getPBPDDExceptionNotes()
//   const exceptionTitle = exceptionNotes.title
//   const [
//     firstExceptionTitle,
//     firstExceptionDetail,
//     secondExceptionTitle,
//     secondExceptionDetail,
//     secondExceptionDetailExtend,
//   ] = exceptionNotes.exceptions

//   const renderSubItem = (data: string[]) => {
//     return data.map((dataRow, index) => {
//       return (
//         <div className="list-cell" key={`data_${index}`}>
//           &emsp;&ensp;&ensp;<span>{`(${index + 1})`}</span>
//           <span dangerouslySetInnerHTML={{ __html: dataRow }} />
//         </div>
//       )
//     })
//   }

//   return (
//     <div id="meh-exception-note32">
//       <p></p>
//       <b>{exceptionTitle}</b>
//       <div>{firstExceptionTitle}</div>
//       <ol>{renderListItems(firstExceptionDetail, 0, 1)}</ol>
//       <div>{secondExceptionTitle}</div>
//       <ol style={{ 'margin-bottom': '0' }}>{renderListItems(secondExceptionDetail, 0, 7)}</ol>
//       <div>{renderSubItem(secondExceptionDetailExtend)}</div>
//     </div>
//   )
// }

const PBPDDRiderBenefit = ({ rider, sumAssured }) => {
  const description = `ผลประโยชน์ ${MESSAGES.PB_FIT_NAME}`
  const benefitTable = (
    <div className="details-table">
      <p>{MESSAGES.PBPDD_RIDER_DETAIL}</p>
      {sumAssured > rider.defaultSumAssured ? <p className="remark"> {MESSAGES.PB_BENEFIT_REMARK} </p> : ''}
    </div>
  )

  const benefitRider = { ...rider, description }
  return (
    <RiderWithBenefitModal
      id="pbpdd-rider-benefit"
      className="rider pbpdd-rider"
      title={description}
      modalChildren={benefitTable}
    >
      <RiderBenefitSummary rider={benefitRider} />
      {benefitTable}

      <AgentProtectionDisclaimer rider={rider} />
    </RiderWithBenefitModal>
  )
}

export default PBPDDRiderBenefit
